import GoogleMapsSuburbAutocomplete from '../modules/location-autocomplete';

const MAX_WAIT_MS = 5000;
const POLL_INTERVAL_MS = 100;

function isGoogleMapsPlacesReady() {
    return !!(window.google && window.google.maps && window.google.maps.places);
}

function waitForGoogleMapsPlaces(timeoutMs = MAX_WAIT_MS) {
    return new Promise((resolve) => {
        if (isGoogleMapsPlacesReady()) {
            resolve(true);
            return;
        }

        const startedAt = Date.now();
        const intervalId = setInterval(() => {
            if (isGoogleMapsPlacesReady()) {
                clearInterval(intervalId);
                resolve(true);
                return;
            }

            if (Date.now() - startedAt >= timeoutMs) {
                clearInterval(intervalId);
                resolve(false);
            }
        }, POLL_INTERVAL_MS);
    });
}

async function init() {
    const autocompleteFields = [
        ...document.querySelectorAll('[data-js-suburb-autocomplete]'),
    ];

    if (autocompleteFields.length === 0) {
        return;
    }

    const ready = await waitForGoogleMapsPlaces();

    // If Maps API never loaded (slow network, blocked script, ad-blocker, etc.),
    // skip silently rather than throwing — the input stays as a plain text field.
    if (!ready) {
        return;
    }

    autocompleteFields.forEach(
        (el) =>
            new GoogleMapsSuburbAutocomplete(el, (place) =>
                handlePlaceChange(el, place),
            ),
    );
}

function handlePlaceChange(el, place) {
    if (!el || !place) {
        return;
    }

    const fields = [
        ...el.closest('form').querySelectorAll('input.suburb-autocomplete'),
    ];

    fields.forEach((field) => {
        const attr = field.id;
        switch (attr) {
            case 'lat':
                field.value = place?.geometry?.location?.lat() ?? '-37.8136276';
                break;
            case 'lng':
                field.value = place?.geometry?.location?.lng() ?? '144.9630576';
                break;
            default:
                break;
        }
    });
}

document.addEventListener('DOMContentLoaded', init);
